import { Alert, IconButton, Snackbar } from "@mui/material";
import { CircleAlert, Info, ThumbsUp, TriangleAlert, X } from "lucide-react";
import { forwardRef } from "react";
import { SIZES } from "../../constants/sizes";
import { SPACING } from "../../constants/spacing";

const ICON_SIZE = 20;

const variantConfig = {
  success: {
    icon: ThumbsUp,
    color: "success",
  },
  error: {
    icon: CircleAlert,
    color: "error",
  },
  warning: {
    icon: TriangleAlert,
    color: "warning",
  },
  info: {
    icon: Info,
    color: "info",
  },
};

const Toast = forwardRef(({ toast, onClose }, ref) => {
  const config = variantConfig[toast.variant] || variantConfig.info;
  const IconComponent = config.icon;

  return (
    <Snackbar
      ref={ref}
      open={toast.open}
      autoHideDuration={toast.duration}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      sx={{ mx: SPACING.xl }}
    >
      <Alert
        variant="filled"
        severity={config.color}
        icon={<IconComponent size={ICON_SIZE} />}
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={onClose}
            sx={{ ml: 1 }}
          >
            <X size={18} />
          </IconButton>
        }
        sx={{
          width: "100%",
          minWidth: "300px",
          maxWidth: "500px",
          boxShadow: 3,
          "& .MuiAlert-icon": {
            marginRight: SPACING.sm,
          },
          "& .MuiAlert-message": {
            fontSize: SIZES.bodyMd,
            fontWeight: "400 !important",
          },
        }}
      >
        {toast.message}
      </Alert>
    </Snackbar>
  );
});

Toast.displayName = "Toast";

export default Toast;
